import React from "react";
import { Button, Typography, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import NavBar from "../NavBar";
import AppFooter from "../footer";
import { t } from "i18next";

const ErrorPage = ({ message, onRetry }) => {
  return (
    <>
      <NavBar />
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          backgroundColor: "#f8f8f8",
        }}
      >
        <ErrorIcon sx={{ fontSize: 100, color: "#ff6f61" }} />
        <Typography variant="h4" gutterBottom>
          {t("somethingWentWrong")}
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ marginBottom: 3 }}
        >
          {message || t("unexpectedError")}
        </Typography>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={onRetry}
            sx={{ marginRight: 2, textTransform: "capitalize" }}
          >
            {t("retry")}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => window.location.reload()}
          >
            {t("reloadPage")}
          </Button>
        </Box>
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default ErrorPage;
